<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="Clases">
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark> mdi-keyboard-backspace </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary--text d-flex align-center flex-wrap">
          Secretaria Virtual
          <v-switch
            v-model="switchNewVersion"
            label="Probar nueva versión"
            @change="goToNewVersion"
            hide-details
            class="ml-4 mt-0 pt-0"
          ></v-switch>
        </div>
      </v-col>

      <v-row no-gutters v-if="horarios.length == 0 && show == true">
        <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
          <v-alert
            prominent
            type="info"
          >
            No hay Horarios disponibles en estos momentos
          </v-alert>
        </v-col>
      </v-row>

      <v-expansion-panels class="mb-12" v-else>
        <v-expansion-panel v-for="(item, index) in horarios" :key="index">
          <v-expansion-panel-header>
             <h3 class="font-weight-black"> {{item.titulo}} </h3>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <p class="font-weight-black"
              >Horario de atencion : {{ item.horaDesde }} hasta
              {{ item.horaHasta }}
            </p>
            <p>{{ item.notas }}</p>
            <a :href="item.meet" class="text-decoration-underline font-italic"
              >Ingresar al enlace</a
            >
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </CardIeaAppMain>
  </div>
</template>

<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Secretaria",
  components: {
    CardIeaAppMain,
  },

  data() {
    return {
      horarios: [],
      show: false,
      switchNewVersion: false
    };
  },
 
  methods: {
    listaHorarios() {
      this.$API
        .get({
          url: "secretaria/I",
        })
        .then((res) => {
          this.horarios = res;
          this.show = true;
        });
    },

    goToNewVersion() {
      this.$router.push({ name: "Secretaria" });
    }
  },

   mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true || this.$store.getters.user.excedente){
      this.$router.push({
          name: "Home"
        });
    }
    this.listaHorarios();
  },
};
</script>